import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      activeModalityId: state => state.App.activeModalityId,
      modality_name: state => state.App.activeModalityName,
      activeModalitySolution: state => state.App.activeModalitySolution,
    }),
  },
}